module.exports = __webpack_public_path__ + "static/media/2_pl.c95e6e92.png";